import config from 'config';
import { http_client } from './api';

const getList = async (page = null, perPage = null, sort = null, orderBy = null, search = null, cabangId = null, month = null, year = null) => {
  return http_client
    .get(
      config.apiUrl +
        'operational-balance?' +
        `${perPage ? 'perPage=' + perPage : ''}` +
        `${page ? '&page=' + page : ''}` +
        `${orderBy ? '&orderBy=' + orderBy : ''}` +
        `${sort ? '&sort=' + sort : ''}` +
        `${search ? '&search=' + search : ''}` +
        `${cabangId ? '&cabang_id=' + cabangId : ''}` +
        `${month ? '&month=' + month : ''}` +
        `${year ? '&year=' + year : ''}`
    )
    .then((response) => {
      return response.data;
    });
};

const create = async (data) => {
  return http_client.post(config.apiUrl + 'operational-balance', data).then((response) => {
    return response.data;
  });
};

const read = async (id) => {
  return http_client.get(config.apiUrl + 'operational-balance/' + id).then((response) => {
    return response.data;
  });
};

const update = async (id, data) => {
  return http_client.post(config.apiUrl + 'operational-balance/' + id, data).then((response) => {
    return response.data;
  });
};

const del = async (id) => {
  return http_client.delete(config.apiUrl + 'operational-balance/' + id).then((response) => {
    return response.data;
  });
};

const getRemainingBalance = async (cabangId, month = null, year = null) => {
  return http_client
    .get(
      config.apiUrl +
        'operational-balance/remaining/' +
        cabangId +
        '?' +
        `${month ? 'month=' + month : ''}` +
        `${year ? '&year=' + year : ''}`
    )
    .then((response) => {
      return response.data;
    });
};

const getAllRemainingBalance = async (month = null, year = null) => {
  return http_client
    .get(
      config.apiUrl +
        'operational-balance/all-remaining?' +
        `${month ? 'month=' + month : ''}` +
        `${year ? '&year=' + year : ''}`
    )
    .then((response) => {
      return response.data;
    });
};

const getTopupDetail = async (cabangId, month = null, year = null) => {
  return http_client
    .get(
      config.apiUrl +
        'operational-balance/topup-detail/' +
        cabangId +
        '?' +
        `${month ? 'month=' + month : ''}` +
        `${year ? '&year=' + year : ''}`
    )
    .then((response) => {
      return response.data;
    });
};

const getListArchive = async (page = null, perPage = null, sort = null, orderBy = null, search = null, cabangId = null, startDate = null, endDate = null, createdBy = null) => {
  return http_client
    .get(
      config.apiUrl +
        'operational-balance/archive?' +
        `${perPage ? 'perPage=' + perPage : ''}` +
        `${page ? '&page=' + page : ''}` +
        `${orderBy ? '&orderBy=' + orderBy : ''}` +
        `${sort ? '&sort=' + sort : ''}` +
        `${search ? '&search=' + search : ''}` +
        `${cabangId ? '&cabang_id=' + cabangId : ''}` +
        `${startDate ? '&start_date=' + startDate : ''}` +
        `${endDate ? '&end_date=' + endDate : ''}` +
        `${createdBy ? '&created_by=' + createdBy : ''}`
    )
    .then((response) => {
      return response.data;
    });
};

const changeStatus = async (id, status) => {
  return http_client.post(config.apiUrl + 'operational-balance/status/' + id, { status }).then((response) => {
    return response.data;
  });
};

const permanentDelete = async (id) => {
  return http_client.delete(config.apiUrl + 'operational-balance/permanent/' + id).then((response) => {
    return response.data;
  });
};

const SaldoOperasionalService = {
  getList,
  getListArchive,
  create,
  read,
  update,
  del,
  getRemainingBalance,
  getAllRemainingBalance,
  getTopupDetail,
  changeStatus,
  permanentDelete
};

export default SaldoOperasionalService;

